import React, {useEffect, useState} from 'react';
import { ComponentType } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Stack,
  Chip,
  Tooltip,
  IconButton,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
  Dialog,
  Table,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import api from '../../../services/api';
import CircularProgress from '@mui/material/CircularProgress';
import {
  ClearRounded,
  DownloadRounded,
  Person2Rounded,
} from '@mui/icons-material';
import Box from '@mui/material/Box';
import { toaster } from '../../../services/toaster';
import DialogContent from '@mui/material/DialogContent';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Step} from "react-joyride";
import {downloadAttachment} from "../../../utils/downloadAttachment";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: any) {
  return {
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface Props {
  key: number;
  item: any;
  onClick: () => void;
  onRegisterSteps?: (steps: Step[]) => void;
}

export const GroupCard: ComponentType<Props> = ({ key, item, onClick,onRegisterSteps }) => {
  const [expanded, setExpanded] = useState(false);
  const [data, setData] = useState<any>(null);
  const [viewActivity, setViewActivity] = useState<any>(null);

  useEffect(() => {
    if(!key){
      const e = null;
      toggleExpanded(e, item);
    }
  }, []);

  const toggleExpanded = (event: any, item: any) => {
    if(event){
      event.stopPropagation();
    }
    setExpanded((v) => !v);
    if (!expanded) {
      api
        .get(`/guide/guide-schedule/${item?.id}`)
        .then((result: any) => {
          setData(result);
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    if(key){
      return;
    }
    const items:any = [
      {
        target: "#group-name",
        title: "Group",
        content: "Here you see the group name",
        placement: "bottom",
      },
      {
        target: "#first-activity",
        title: "First Activity",
        content: "Here you can see when the group has its first activity",
        placement: "bottom",
      },
      {
        target: "#last-activity",
        title: "Last Activity",
        content: "Here you can see when the group has its last activity",
        placement: "bottom",
      },
      {
        target: "#guide-schedule-download",
        title: "Guide Schedule",
        content: "Click this button to download the Guide Schedule",
        placement: "bottom",
      },
      {
        target: "#open-activity-reservations",
        title: "Activities / Accommodations",
        content: "Click this button to view the group’s activities and accommodations",
        placement: "bottom",
      },
      {
        target: "#open-activities",
        title: "Activities",
        content: "Click this tab to view the group’s activities",
        placement: "bottom",
      },
      {
        target: "#open-accommodations",
        title: "Accommodations",
        content: "Click this tab to view the group’s accommodations",
        placement: "bottom",
      },
    ];

    if(data && data?.activity_reservation.length){
      items.push( {
        target: "#open-activity-information",
        title: "Activity Information",
        content: "Click on the activity to view information",
        placement: "bottom",
      },);
    }

    onRegisterSteps?.(items);
  }, [onRegisterSteps]);

  const handleDownload = async (attachment: any) => {
    try {
      await downloadAttachment(attachment, api.getFile);
    } catch (error) {
      console.log(error);
      toaster.show({
        icon: 'error',
        message: `Error while download data`,
        intent: 'danger',
      });
    }
    return true;
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <>
      <Card
        sx={{
          width: '100%',
          position: 'relative',
          borderRadius: '10px',
          boxShadow: '0 4px 5px rgba(0, 0, 0, 0.2)',
          '& .MuiCardHeader-subheader': {
            mt: '10px',
          },
          cursor: 'pointer',
          '&:hover': {
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#f9f9f9',
          },
        }}
        onClick={() => onClick()}
      >
        <CardHeader
          title={
            <Typography id={'group-name'} variant={'body1'}>
              <b>Csoport:</b> {item?.name}
            </Typography>
          }
          subheader={
            <>
              <Stack
                position="relative"
                direction="row"
                justifyContent="space-between"
                alignItems={'flex-start'}
              >
                <Stack gap={1}>
                  <Chip
                    id={'first-activity'}
                    size="small"
                    color="default"
                    variant="filled"
                    label={
                      <Typography variant={'caption'}>
                        <b>First activity start:</b> {item?.first_activity_date}{' '}
                        {item?.first_activity_start_time}
                      </Typography>
                    }
                  />
                  <Chip
                    id={'last-activity'}
                    size="small"
                    color="default"
                    variant="filled"
                    label={
                      <Typography variant={'caption'}>
                        <b>Last activity start:</b> {item?.last_activity_date}{' '}
                        {item?.last_activity_start_time}
                      </Typography>
                    }
                  />
                </Stack>

                <Stack
                  sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                  }}
                  direction={'row'}
                  gap={1}
                >
                  <Tooltip title={'Download Roadbook'}>
                    <IconButton
                      id={'guide-schedule-download'}
                      sx={{
                        background: '#ececec !important',
                        color: !item?.roadbook_id
                          ? 'rgba(0, 0, 0, 0.26) !important'
                          : '#000!important',
                      }}
                      disabled={!item?.roadbook_id}
                      onClick={() => {
                        handleDownload(item?.roadbook);
                      }}
                      size={'small'}
                    >
                      <DownloadRounded />
                    </IconButton>
                  </Tooltip>
                  <Tooltip
                    title={expanded ? 'Hide activities' : 'Show activities'}
                  >
                    <IconButton
                      id={'open-activity-reservations'}
                      onClick={(e) => toggleExpanded(e, item)}
                      size="small"
                      aria-expanded={expanded}
                      aria-label="toggle more"
                      sx={{
                        transition: 'transform .2s ease',
                        transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        background: '#ececec',
                      }}
                    >
                      <KeyboardArrowDownIcon />
                    </IconButton>
                  </Tooltip>
                </Stack>
              </Stack>
            </>
          }
          sx={{
            '& .MuiCardHeader-subheader': {
              mt: '5px',
            },
            '@media (max-width:600px)': {
              //p: '8px',
            },
          }}
        />
        {/* Animáltan nyíló rész */}
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Divider />

          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                id={'open-activities'}
                sx={{
                  fontSize: '11px',
                }}
                label="Activities"
                {...a11yProps(0)}
              />
              <Tab
                id={'open-accommodations'}
                sx={{
                  fontSize: '11px',
                }}
                label="Accommodations"
                {...a11yProps(1)}
              />
            </Tabs>
          </Box>

          <CardContent
            sx={{
              p: '16px !important',
            }}
          >
            <CustomTabPanel value={value} index={0}>
              <List
                sx={{
                  p: 0,
                }}
                dense={true}
              >
                {!data ? (
                  <ListItem
                    sx={{
                      justifyContent: 'center',
                      background: '#ececec',
                      borderRadius: '10px',
                      py: '6px',
                    }}
                  >
                    <CircularProgress size={30} color="primary" />
                  </ListItem>
                ) : (
                  <>
                    {data?.activity_reservations.map(
                      (activityReservation: any, index:any) => {
                        return (
                          <ListItem
                            id={!index ? 'open-activity-information':''}
                            sx={{
                              background: !activityReservation?.isGuideSelectedInReservation ? '#ececec' : '#dbebff',
                              borderRadius: '10px',
                              py: '6px',
                              pl: '6px',
                              mb: '5px',
                            }}
                            secondaryAction={
                              <>
                                <Tooltip title={activityReservation?.isGuideSelectedInReservation? 'You are the guide': 'You’re not the guide'}>
                                  <IconButton
                                    sx={{
                                      position: 'relative',
                                    }}
                                    size={'small'}
                                  >
                                    <Person2Rounded color={activityReservation?.isGuideSelectedInReservation?'primary':'disabled'} fontSize={'small'} />

                                    {!activityReservation?.isGuideSelectedInReservation && (
                                      <Box
                                        sx={{
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                      >
                                        <ClearRounded
                                          sx={{
                                            fontSize: '11px',
                                          }}
                                        />
                                      </Box>
                                    )}
                                  </IconButton>
                                </Tooltip>
                              </>
                            }
                          >
                            <ListItemText
                              sx={{
                                my: '3px',
                              }}
                              primary={activityReservation?.name}
                              secondary={`${activityReservation.date} ${activityReservation.start_time}`}
                              onClick={() => {

                                let pickupFrom = activityReservation.address_from?.name ? activityReservation.address_from?.name : '';
                                if (activityReservation.address_from?.address_line1){
                                  if (pickupFrom === ''){
                                    pickupFrom = activityReservation?.address_from?.address_line1;
                                  }else{
                                    pickupFrom = `${pickupFrom} (${activityReservation?.address_from?.address_line1})`;
                                  }
                                }
                                activityReservation.pickupFrom = pickupFrom;

                                let activityWhere = activityReservation.address_to?.name ? activityReservation.address_to?.name : '';
                                if (activityReservation.address_to?.address_line1) {
                                  if (activityWhere === '') {
                                    activityWhere = activityReservation?.address_to?.address_line1;
                                  } else {
                                    activityWhere = `${activityWhere} (${activityReservation?.address_to?.address_line1})`;
                                  }

                                }

                                activityReservation.activityWhere = activityWhere;

                                setViewActivity(activityReservation);
                              }}
                            />
                          </ListItem>
                        );
                      }
                    )}
                  </>
                )}
              </List>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <List
                sx={{
                  p: 0,
                }}
                dense={true}
              >
                {!data ? (
                  <ListItem
                    sx={{
                      justifyContent: 'center',
                      background: '#ececec',
                      borderRadius: '10px',
                      py: '6px',
                    }}
                  >
                    <CircularProgress size={30} color="primary" />
                  </ListItem>
                ) : (
                  <>
                    {data?.bookings.map((accommodationReservation: any) => {
                      let nights: any = '-';
                      const dep = accommodationReservation.departure;
                      const arr = accommodationReservation.arrival;

                      if (dep && arr) {
                        const depDate = new Date(dep);
                        const arrDate = new Date(arr);

                        const differenceInTime =
                          depDate.getTime() - arrDate.getTime();
                        const differenceInDays =
                          differenceInTime / (1000 * 60 * 60 * 24);

                        nights = Math.max(1, differenceInDays);
                      }

                      return (
                        <ListItem
                          sx={{
                            background: '#ececec',
                            borderRadius: '10px',
                            py: '6px',
                            pl: '6px',
                            mb: '5px',
                          }}
                        >
                          <ListItemText
                            sx={{
                              my: '3px',
                            }}
                            primary={
                              accommodationReservation?.accommodation?.name
                            }
                            secondary={
                              <>
                                <Box
                                  sx={{
                                    pt: '5px',
                                    '& .MuiTableCell-root': {
                                      p: '2px',
                                    },
                                  }}
                                >
                                  <Table key={accommodationReservation?.id}>
                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          width: '60px',
                                        }}
                                      >
                                        Address:
                                      </TableCell>
                                      <TableCell>
                                        {accommodationReservation.accommodation.addresses.map(
                                          (addr: any, index: number) => {
                                            let name = '';
                                            if (addr?.name) {
                                              name = addr.name;
                                              if (addr?.address_line1) {
                                                name = `${name} (${addr.address_line1})`;
                                              }
                                            } else {
                                              name = addr?.address_line1;
                                            }

                                            return (
                                              <div key={index}>{name}</div>
                                            );
                                          }
                                        )}
                                      </TableCell>
                                    </TableRow>
                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          width: '60px',
                                        }}
                                      >
                                        Booked for:
                                      </TableCell>
                                      <TableCell>{nights} nights</TableCell>
                                    </TableRow>

                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          width: '60px',
                                        }}
                                      >
                                        From:
                                      </TableCell>
                                      <TableCell>
                                        {accommodationReservation?.arrival && (
                                          <>
                                            {accommodationReservation.arrival}
                                            {' (' +
                                              new Date(
                                                accommodationReservation.arrival
                                              ).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                              }) +
                                              ')'}
                                          </>
                                        )}
                                      </TableCell>
                                    </TableRow>

                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          width: '60px',
                                        }}
                                      >
                                        To:
                                      </TableCell>
                                      <TableCell>
                                        {accommodationReservation?.departure && (
                                          <>
                                            {accommodationReservation.departure}
                                            {' (' +
                                              new Date(
                                                accommodationReservation.departure
                                              ).toLocaleDateString('en-US', {
                                                weekday: 'short',
                                              }) +
                                              ')'}
                                          </>
                                        )}
                                      </TableCell>
                                    </TableRow>

                                    <TableRow>
                                      <TableCell
                                        sx={{
                                          width: '60px',
                                        }}
                                      >
                                        Booked by:
                                      </TableCell>
                                      <TableCell>
                                        {
                                          accommodationReservation?.booked_by
                                            ?.name
                                        }
                                      </TableCell>
                                    </TableRow>
                                  </Table>
                                </Box>
                              </>
                            }
                          />
                        </ListItem>
                      );
                    })}
                  </>
                )}
              </List>
            </CustomTabPanel>
          </CardContent>

          {/* Opcionális akciók az expanded rész alján */}
        </Collapse>
      </Card>

      {viewActivity && (
        <>
          <Dialog
            fullScreen
            onClose={() => {
              setViewActivity(null);
            }}
            open={true}
            TransitionComponent={Transition}
          >
            <AppBar
              sx={{
                position: 'relative',
                background: '#256861',
              }}
            >
              <Toolbar>
                <Typography
                  sx={{ ml: 2, flex: 1 }}
                  variant="h6"
                  component="div"
                >
                  {viewActivity?.name}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    setViewActivity(null);
                  }}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>

            <DialogContent
              sx={{
                p: '10px',
              }}
            >
              <Box
                sx={{
                  p: '5px',
                  '& .MuiTableCell-root': {
                    p: '2px',
                    fontSize: '12px',
                  },
                }}
              >
                <Table key={viewActivity?.id}>
                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Guide
                    </TableCell>
                    <TableCell>{viewActivity?.guides}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Includes
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          '& *': {
                            fontSize: '11px !important',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: viewActivity?.activity?.includes,
                        }}
                      ></Box>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Guide Infos
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          '& *': {
                            fontSize: '11px !important',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: viewActivity?.activity?.guide_infos,
                        }}
                      ></Box>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Guide Schedule Infos
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          '& *': {
                            fontSize: '11px !important',
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: viewActivity?.activity?.guide_schedule_infos,
                        }}
                      ></Box>
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Activity Provider
                    </TableCell>
                    <TableCell>{viewActivity?.activity_providers}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Transfer Provider
                    </TableCell>
                    <TableCell>{viewActivity?.transfer_providers}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Size
                    </TableCell>
                    <TableCell>{viewActivity?.group_size}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Date
                    </TableCell>
                    <TableCell>{viewActivity?.date}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Meeting
                    </TableCell>
                    <TableCell>{viewActivity?.meeting_time}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Pickup
                    </TableCell>
                    <TableCell>{viewActivity?.pickup_time}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      From
                    </TableCell>
                    <TableCell>{viewActivity?.pickupFrom}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Start
                    </TableCell>
                    <TableCell>{viewActivity?.start_time}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Location
                    </TableCell>
                    <TableCell>{viewActivity?.activityWhere}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Booking Contacts
                    </TableCell>
                    <TableCell>{viewActivity?.contacts}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Staff
                    </TableCell>
                    <TableCell>{viewActivity?.staff_names}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Driver
                    </TableCell>
                    <TableCell>
                      {viewActivity?.drivers.map((driver: any) => {
                        return <div>{driver?.name}</div>;
                      })}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Vehicle
                    </TableCell>
                    <TableCell>
                      {viewActivity?.vehicles.map((driver: any) => {
                        return <div>{driver?.name}</div>;
                      })}
                    </TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      sx={{
                        width: '60px',
                      }}
                    >
                      Files
                    </TableCell>
                    <TableCell>
                      <Stack direction={'row'} gap={'2px'} flexWrap={'wrap'}>
                        {viewActivity?.manual_confirmations ? (
                          <>
                            {viewActivity?.manual_confirmations.map(
                              (file: any, index: any) => {
                                return (
                                  <Chip
                                    label={`${index + 1} confirmation`}
                                    variant="outlined"
                                    onClick={() => handleDownload(file)}
                                  />
                                );
                              }
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                </Table>
              </Box>
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};
